import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, putData, deleteData, FinishData, postData, updateData, DespatchData, OrderDespatchData } from '../../apiService';
import {
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import DatePicker from 'react-datepicker';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ArrowForward from '@mui/icons-material/ArrowForward';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import WrongLocationIcon from '@mui/icons-material/WrongLocation';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';
import SummarizeSharpIcon from '@mui/icons-material/SummarizeSharp';
import CloseIcon from '@mui/icons-material/Close';
//import { IconButton } from '@mui/material';
import AddCardTwoToneIcon from '@mui/icons-material/AddCardTwoTone';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // Importing the new icon

const Home = () => {
  // const { isAuthenticated, companyId, roleName, permissions, userId, token, logout,username } = useAuth();
  const { isAuthenticated, companyId, roleName, permissions, userId, token, logout, username } = useAuth();
  const hasCreateTransactionPermission = permissions && permissions.includes('Create Transaction');
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const { id } = useParams();
  const history = useHistory();
  const [Tripdata, setTripData] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [orderCutsomerdata, setOrderCutsomerData] = useState([]);
  const [startAutometereReading, setStartAutometereReading] = useState("");
  const [endAutometereReading, setEndAutometereReading] = useState("");
  const [isSubmit, setisSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [otherName, setOtherName] = useState("");
  const [deltripid, setdeltripid] = useState(null);


  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }

    if (isAuthenticated) {
      fetchTableData();
    }
  }, [isAuthenticated, companyId, roleName, username, userId, token, logout, id]);
  const fetchTableData = async () => {
    try {
      const response = await fetchData('TripApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        setTripData(response.response_data);
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching Table Data', error);
    }
  };



  //Trip api fetch
  const [tripid, setTripId] = useState();
  const [customerId, setCustomerId] = useState();
  const [GetDat, setGetData] = useState();

  const fetchItemData = async (tripid) => {
    try {
      const response = await fetchData('TripApi', `/UnOrderedCustomer/${tripid}`, token);
      if (response.responseCode === '1111') {
        setOrderCutsomerData(response.response_data.Customers);
        setCustomerId(response.response_data.Customers.ID);
        setTripId(response.response_data.Id);
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching Table Data', error);
    }
  };

  const handleRouteClick = (trip) => {
    setSelectedTrip(trip);
    fetchItemData(trip.Id);
  };

  const handleDelete = async () => {
    try {
      await FinishData('TripApi', `${deleteItemId}`, token);
      fetchTableData();
      setDeleteItemId(null);
      setConfirmDialogOpen(true);
      history.push('/Home');
      window.location.reload();
    } catch (error) {
      console.error('Error deleting record:', error);
    }
  };
  const handleTripDelete = async (deltripid) => {
    try {
      await deleteData('TripAllocateApi', `${deltripid}`, token);
      setdeltripid(null)
      history.push('/Home');
      window.location.reload();
    } catch (error) {
      console.error('Error deleting record:', error);
    }
  };
  const openConfirmDialog = (id) => {
    setDeleteItemId(id);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setConfirmDialogOpen(false);
    setDeleteItemId(null);
  };


  useEffect(() => {
    fetchtableDatas();
  }, []);

  const [TripAllocateData, setTripallocateData] = useState([]);
  const fetchtableDatas = async () => {
    try {
      const response = await fetchData('TripAllocateApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        setTripallocateData(response.response_data);
        setGetData(response.response_data.tripid)
      }
    } catch (error) {
      console.error('Error fetching item details:', error);
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };


  useEffect(() => {
    fetchtableDatasAllocate();
  }, []);

  const [TripAllocateTostaff, setTripallocateTostaff] = useState([]);
  const fetchtableDatasAllocate = async () => {
    try {
      const response = await fetchData('GstReport', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        setTripallocateTostaff(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching item details:', error);
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };

  //SalesMan

  const [selectedProduct, setSelectedProduct] = useState("");
  const [salesManOptions, setSalesManOptions] = useState([]);
  const [selectedSalesMan, setSelectedSalesMan] = useState("");

  const fetchSalesMan = async () => {
    try {
      // const response = await fetchData('executiveApi', `/${companyId}`, token);

      const response = await fetchData('executiveApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(product => ({
          value: product.id,
          label: product.firstName
        }));
        setSalesManOptions(options);
      }
    } catch (error) {
      console.error('Error fetching route:', error);
    }
  };
  const handleSalesManChange = (selectedOption) => {
    setSelectedSalesMan(selectedOption);
  };

  useEffect(() => {
    fetchSalesMan();
  }, []);


  //Driver

  const [driverOptions, setDriverOptions] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState("");

  const fetchDriver = async () => {
    try {
      // const response = await fetchData('StaffSelectionApi', `/${companyId}`, token);
      const response = await fetchData('DriverstaffApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(product => ({
          value: product.id,
          label: product.firstName
        }));
        setDriverOptions(options);
      }
    } catch (error) {
      console.error('Error fetching route:', error);
    }
  };
  const handleDriverChange = (selectedOption) => {
    setSelectedDriver(selectedOption);
  };

  useEffect(() => {
    fetchDriver();
  }, []);
  // // fetch vehicle odometer 


  //vehicletype

  const [vehicletypeId, setvehicletypeId] = useState('');
  const [vehicletypeOptions, setvehicletypeOptions] = useState([]);
  const [selectedvehicletype, setSelectedvehicletype] = useState(null);


  useEffect(() => {
    const fetchVehicleTypes = async () => {
      try {
        const response = await fetchData('VehicleTypeApi', `/${companyId}`, token);

        if (response.responseCode === '1111') {
          const dataArray = response.response_data;
          const options = response.response_data.map(vehtype => ({
            value: vehtype.id,
            label: vehtype.name
          }));
          setvehicletypeOptions(options);
        }
      } catch (error) {
        console.error('Error fetching vehicle models:', error);
      }
    };

    fetchVehicleTypes();
  }, [companyId, token]);

  //Vehicle
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");

  const handleVehicletypeChange = async (selectedOption) => {
    setSelectedvehicletype(selectedOption);

    try {
      const response = await fetchData('VehicleTypeApi', `/${companyId}/${selectedOption.value}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(vehicle => ({
          value: vehicle.id,
          label: vehicle.vehicleNo
        }));
        setVehicleOptions(options);
      }
    } catch (error) {
      console.error('Error fetching vehicle options:', error);
    }
  };




  const fetchVehicleDetails = async (vehicleId) => {
    try {
      const response = await fetchData('TripAllocateApi', `/${companyId}/${vehicleId}`, token);
      if (response.responseCode === '1111') {
        setStartAutometereReading(response.response_data.EndAudometereReading);
      }
    } catch (error) {
      console.error('Error fetching vehicle details:', error);
      // Handle errors, e.g., logout on unauthorized
    }
  };

  const handleVehicleChange = (selectedOption) => {
    setSelectedVehicle(selectedOption);
  };

  // Schedule Staff To Trip
  const [selectedItem, setSelectedItem] = useState(null);
  const handleScheduleStaff = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
  };

  //   //Trip Allocated
  //   const submitData = async (e) => {
  //     e.preventDefault();

  //  // ✅ Validation checks
  //   if (!selectedSalesMan?.value) {
  //     setErrorMessage("Please select a Salesman.");
  //     return;
  //   }

  //   if (!selectedDriver?.value) {
  //     setErrorMessage("Please select a Driver.");
  //     return;
  //   }

  //   if (!startAutometereReading) {
  //     setErrorMessage("Please enter Start Odometer Reading.");
  //     return;
  //   }

  //     const CreateData = {
  //       Id: selectedItem.id,
  //       Description: selectedItem.description,
  //       IsActive: selectedItem.isActive,
  //       IsTripFinish: selectedItem.isTripFinish,
  //       OrderDate: selectedItem.orderDate,
  //       CreatedBy: selectedItem.createdBy,
  //       CreatedDate: selectedItem.createdDate,
  //       TripDate: selectedItem.tripDate,
  //       TripNo: selectedItem.tripNo,
  //       RouteId: selectedItem.routeId,
  //       SalesManId: selectedSalesMan.value,
  //       DriverId: selectedDriver.value,
  //       VehicleId: selectedVehicle.value,
  //       Name: otherName || null,
  //       StartAudometereReading: startAutometereReading || selectedItem.startAudometereReading || null,
  //       EndAudometereReading: endAutometereReading || selectedItem.endAudometereReading || null,
  //       ModifiedBy: userId,
  //       CompanyId: companyId,
  //       ModifiedDate: new Date(),
  //     };

  //     // updateData('TripApi', CreateData, token)
  //     const tripID = selectedItem.id;

  //     updateData('TripApi', `${tripID}`, CreateData, token)
  //       .then((response) => {
  //         console.log('trip Updated success:', response);
  //         setSuccessMessage("Trip Created successfully!");
  //         setErrorMessage("");
  //         setSelectedDriver("");
  //         //setSelectedVehicle("");
  //         setSelectedSalesMan("");
  //         setStartAutometereReading("");
  //         setEndAutometereReading("");
  //         history.push('/Home');
  //         window.location.reload();
  //         setShowModal(false);
  //         setTimeout(() => {
  //           setSuccessMessage("");
  //         }, 3000);
  //       })
  //       .catch((error) => {
  //         console.error('Trip Updated error:', error);
  //         setIsLoading(false);
  //       });
  //   };
  const submitData = async (e) => {
    e.preventDefault();

    // ✅ Validation checks
    if (!selectedSalesMan?.value) {
      setErrorMessage("Please select a Salesman.");
      return;
    }

    if (!selectedDriver?.value) {
      setErrorMessage("Please select a Driver.");
      return;
    }

  
    setErrorMessage(""); // clear old errors if validation passes

    const CreateData = {
      Id: selectedItem.id,
      Description: selectedItem.description,
      IsActive: selectedItem.isActive,
      IsTripFinish: selectedItem.isTripFinish,
      OrderDate: selectedItem.orderDate,
      CreatedBy: selectedItem.createdBy,
      CreatedDate: selectedItem.createdDate,
      TripDate: selectedItem.tripDate,
      TripNo: selectedItem.tripNo,
      RouteId: selectedItem.routeId,
      SalesManId: selectedSalesMan.value,
      DriverId: selectedDriver.value,
      VehicleId: selectedVehicle.value,
      Name: otherName || null,
      StartAudometereReading: startAutometereReading || selectedItem.startAudometereReading || null,
      EndAudometereReading: endAutometereReading || selectedItem.endAudometereReading || null,
      ModifiedBy: userId,
      CompanyId: companyId,
      ModifiedDate: new Date(),
    };

    const tripID = selectedItem.id;

    updateData('TripApi', `${tripID}`, CreateData, token)
      .then((response) => {
        console.log('trip Updated success:', response);
        setSuccessMessage("Trip Created successfully!");
        setErrorMessage("");
        setSelectedDriver("");
        setSelectedSalesMan("");
        setStartAutometereReading("");
        setEndAutometereReading("");
        history.push('/Home');
        window.location.reload();
        setShowModal(false);
        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      })
      .catch((error) => {
        console.error('Trip Updated error:', error);
        setIsLoading(false);
        setErrorMessage("Something went wrong while updating the trip.");
      });
  };

  // Despatch summary 
  const [showDespatchSUmmaryModal, setDespatchSUmmaryModal] = useState(false);

  const [selecteddespatchItem, setSelectedDespatchItem] = useState(null);

  // const [data, setData] = useState([]);
  const [executive, setexecutive] = useState([]);
  const [orderTakenby, setorderTakenby] = useState([]);



  const [data, setData] = useState([]);

  const handleDespatched = async (item) => {
    setSelectedDespatchItem(item);
    setDespatchSUmmaryModal(true);

    try {
      const dateObject = new Date(item.tripDate);
      const day = dateObject.getDate().toString().padStart(2, '0');
      const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
      const year = dateObject.getFullYear().toString();
      const tripDate = `${year}-${month}-${day}`;

      const tripId = item.id;
      const response = await OrderDespatchData('OrderTypeDespatchAPI', companyId, tripId, token);

      if (response.responseCode === '1111') {
        const dataArray = response.response_data;

        if (dataArray.length > 0) {
          setData(dataArray);
          setorderTakenby(dataArray[0].OrderTakenBy);
          setexecutive(dataArray[0].Executive);

          console.log('OrderTakenBy:', dataArray[0].OrderTakenBy);
          console.log('Executive:', dataArray[0].Executive);
        } else {
          console.error('No data returned in response.');
        }
      } else {
        console.error('Error in response: ', response);
      }
    } catch (error) {
      console.error('Error fetching route:', error);
    }
  };


  const closeDespatchModal = () => {
    setDespatchSUmmaryModal(false);
  };


  const getRowColor = (balanceQty, weight) => {
    if (balanceQty <= weight / 2) {
      return { backgroundColor: '#FFD0D0' };
    }
    else if (balanceQty <= weight / 3) {
      return { backgroundColor: '#FFFFE0' };
    }
    else {
      return {}; // Default style
    }
  };


  const handlePrint = () => {
    const printWindow = window.open('', '_blank');

    printWindow.document.write(`
    <html>
      <head>
        <title>Despatch Summary</title>
      <style>
          body {
            font-family: "Times New Roman", serif;
            margin: 20px;
          }
          h3 {
            font-size: 32px;
            text-align: center;
            margin-bottom: 30px;
            text-decoration: underline;
          }
          .details {
            margin-bottom: 25px;
            font-size: 18px;
            line-height: 1.5;
          }
          .details p {
            margin: 4px 0;
            word-wrap: break-word;   /* long text will wrap */
            white-space: normal;     /* avoid overflow */
            text-align: justify;     /* aligns neatly to both sides */
          }
          table {
            border-collapse: collapse;
            width: 100%;
            margin-top: 15px;
          }
          thead {
            background-color: #f3f3f3;
          }
          th, td {
            border: 1px solid #444;
            padding: 6px 8px;
            font-size: 16px;
            text-align: left;
          }
          th {
            font-size: 18px;
            font-weight: bold;
            color: black;
          }

            @page {
                  
                 margin: 10px 10px;
                }
                           

                h2 {
                 margin-top: 25px;
                 margin-bottom: 10px;
                }
                thead {
                   display: table-header-group;
                   }
          tr:nth-child(even) {
            background-color: #fafafa;
          }
        </style>


      </head>
      <body>
        <h3>Despatch Summary</h3>
  `);

    // Print route, order taken by, salesman, and order date above the table
    if (data.length > 0) {
      const firstRow = data[0];
      printWindow.document.write('<div class="details">');
      printWindow.document.write(
        `<p>
      <strong>Route:</strong> ${firstRow.RouteName || ''} |
      <strong>Order Taken by:</strong> ${firstRow.OrderTakenBy || ''} |
      <strong>Sales Executive:</strong> ${firstRow.Executive || ''} |
      <strong>Order Date:</strong> ${firstRow.OrderDate ? new Date(firstRow.OrderDate).toLocaleDateString('en-GB') : ''}

     
    </p>`
      );
      printWindow.document.write('</div>');
    }


    // Table header
    printWindow.document.write(`
    <table>
      <thead>
        <tr>
          <th>Sl.No</th>
          <th>Order Type</th>
          <th>Product Category</th>
          <th>Category</th>
          <th>Item Code</th>
          <th>Item</th>
          <th>UOM (Kgs)</th>
          <th>Bundle</th>
          <th>Pieces</th>
          <th>Quantity</th>
          <th>Total Quantity</th>
          <th>Active Customers</th>
          <th>Sale Remarks</th>
        </tr>
      </thead>
      <tbody>
  `);

    // Rows
    let previousValues = {
      OrderTypeName: '',
      ProductCategory: '',
      Category: '',
      CustomerId: '',
      SaleRemarks: ''
    };

    data.forEach((rowData, index) => {
      printWindow.document.write('<tr>');
      printWindow.document.write(`<td>${index + 1}</td>`);
      printWindow.document.write(`<td>${rowData.OrderTypeName !== previousValues.OrderTypeName ? rowData.OrderTypeName : ''}</td>`);
      printWindow.document.write(`<td>${rowData.ProductCategory !== previousValues.ProductCategory ? rowData.ProductCategory : ''}</td>`);
      printWindow.document.write(`<td>${rowData.Category !== previousValues.Category ? rowData.Category : ''}</td>`);
      printWindow.document.write(`<td>${rowData.ItemCode || ''}</td>`);
      printWindow.document.write(`<td>${rowData.Item || ''}</td>`);
      printWindow.document.write(`<td>${rowData.Kilogram || ''}</td>`);
      printWindow.document.write(`<td>${rowData.Bundle || '0'}</td>`);
      printWindow.document.write(`<td>${rowData.Pieces || '0'}</td>`);
      printWindow.document.write(`<td>${rowData.Quantity || ''}</td>`);
      printWindow.document.write(`<td>${rowData.TotalKilogram || ''}</td>`);
      printWindow.document.write(`<td>${rowData.CustomerId && rowData.CustomerId !== previousValues.CustomerId ? rowData.CustomerId : ''}</td>`);
      printWindow.document.write(`<td>${rowData.SaleRemarks && rowData.SaleRemarks !== previousValues.SaleRemarks ? rowData.SaleRemarks : ''}</td>`);
      printWindow.document.write('</tr>');

      previousValues = {
        OrderTypeName: rowData.OrderTypeName,
        ProductCategory: rowData.ProductCategory,
        Category: rowData.Category,
        CustomerId: rowData.CustomerId,
        SaleRemarks: rowData.SaleRemarks
      };
    });

    printWindow.document.write('</tbody></table></body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  // //excel


  const handleExportExcel = () => {
    const excelData = [];

    // Add route, order taken by, order date, and executive as a separate header row
    const topRow = [
      `Route: ${data[0].RouteName}`, // Assuming RouteName is the same for all entries
      `Order Date: ${data[0].OrderDate}`, // Assuming the same OrderDate for all entries
      `Order Taken by: ${data[0].OrderTakenBy}`, // Assuming the same person took all orders
      `Sales Executive: ${data[0].Executive}` // Assuming the same Sales Executive for all entries
    ];

    // Push this information to the first row
    excelData.push(topRow);

    // Add an empty row to separate this information from the rest of the table
    excelData.push([]);

    // Add header row for table data
    const headerRow = [
      'Sl.No', '', 'Product Category', 'Category', 'Item Code', 'Item', 'UOM (Kgs)', 'Bundle', 'Pieces', 'Quantity', 'Total Quantity', 'Active Customers', 'Sale Remarks'
    ];
    excelData.push(headerRow);

    // Add data rows with conditional display logic
    let previousValues = {
      OrderTypeName: '',
      ProductCategory: '',
      Category: '',
      CustomerId: '',
      SaleRemarks: ''
    };

    data.forEach((rowData, index) => {
      const dataRow = [
        index + 1, // Sl.No
        rowData.OrderTypeName !== previousValues.OrderTypeName ? rowData.OrderTypeName : '', // Order Type
        rowData.ProductCategory !== previousValues.ProductCategory ? rowData.ProductCategory : '', // Product Category
        rowData.Category !== previousValues.Category ? rowData.Category : '', // Category
        rowData.ItemCode, // Item Code
        rowData.Item, // Item
        rowData.Kilogram, // UOM (Kgs)
        rowData.Bundle || '0', // Bundle
        rowData.Pieces || '0', // Pieces
        rowData.Quantity, // Quantity
        rowData.TotalKilogram, // Total Quantity
        rowData.CustomerId !== previousValues.CustomerId ? rowData.CustomerId : '', // Active Customers
        rowData.SaleRemarks !== previousValues.SaleRemarks ? rowData.SaleRemarks : '' // Sale Remarks
      ];

      // Push the dataRow to excelData
      excelData.push(dataRow);

      // Update previous values for the next iteration
      previousValues = {
        OrderTypeName: rowData.OrderTypeName,
        ProductCategory: rowData.ProductCategory,
        Category: rowData.Category,
        CustomerId: rowData.CustomerId,
        SaleRemarks: rowData.SaleRemarks
      };
    });

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Despatch Report');

    // Save workbook to a file
    XLSX.writeFile(wb, 'Despatch.xlsx');
  };

  // delivery by salesman

  const [selectedDeliveryCustomer, setSelectedDeliveryCustomer] = useState(null);
  const [DeliveryData, setDeliveryData] = useState([]);
  const [DeliveryDatawithDisplay, setDeliveryDataDisplay] = useState([]);

  useEffect(() => {
    fetchtableDataDelivery();
  }, []);

  const [DTripId, setDeliveryTripId] = useState([]);

  const fetchtableDataDelivery = async () => {
    try {

      const response = await fetchData('DeliveryApi', `/${companyId}/${userId}`, token);
      if (response.responseCode === '1111') {
        setDeliveryData(response.response_data);
        // setDeliveryDataDisplay(response.response_data.customers); // This might be unnecessary
        setDeliveryDataDisplay(response.response_data.customer); // This might be unnecessary
        setDeliveryTripId(response.response_data.id);
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching item details:', error);
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };

  // const handleDeliveryRouteClick = (trip) => {
  //   setSelectedDeliveryCustomer(trip.customer);
  // };

  const handleDeliveryRouteClick = (trip) => {
    setSelectedDeliveryCustomer([]); // Clear the previous trip's customers

    setTimeout(() => {
      setSelectedDeliveryCustomer([...trip.customer]); // Set new trip's customers
    }, 0);
  };


  const deliverytripid = DeliveryData.id;

  const [showModalDeliveredShopRoute, setshowModalDeliveredShopRoute] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [TripClosingdata, setTripClosingData] = useState([]);
  const [OdoMeter, setOdometerReading] = useState(''); // for update by closing the trip after  Completed the ordered item delivered

  // Function to handle clicking on delivery route
  const handleDeliveryRouteClose = async (item) => {
    setSelectedItemId(item.id);
    try {
      //('OfficeExpenseApi', `/ExpenseData/${id}`, token)
      const response = await fetchData('LoginApi', `/tmpType/${item.id}`, token);
      if (response.responseCode === '1111') {
        setTripClosingData(response.response_data);
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching Sale Details:', error);
    }
    setshowModalDeliveredShopRoute(true);
  };

  const closeDeliveredModal = () => {
    setshowModalDeliveredShopRoute(false);
  };


  //Trip Allocated
  const RouteclosingsubmitData = async (e) => {
    e.preventDefault();


    const CreateData = {
      Id: selectedItemId,
      EndAudometereReading: OdoMeter,
      TripClosedBy: userId,
      CompanyId: companyId,
    };

    // updateData('TripApi', CreateData, token)
    const tripID = selectedItemId;

    updateData('LoginApi', `${tripID}`, CreateData, token)
      .then((response) => {
        console.log('trip Updated success:', response);
        setSuccessMessage("Trip Updated successfully!");
        history.push('/Home');
        window.location.reload();
        setShowModal(false);
        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      })
      .catch((error) => {
        console.error('Trip Updated error:', error);
        setIsLoading(false);
      });
  };
  // salesman expense model 



  // Define necessary states
  const [note, setNote] = useState('');
  const [amount, setAmount] = useState('');
  const [itemList, setItemList] = useState([]);
  const [newItem, setNewItem] = useState({});
  const [selectedOption, setSelectedOption] = useState('');
  const [cards, setCards] = useState([]);
  const [ExOdoMeter, setExOdometerReading] = useState('');
  const handleExpenseNameChange = (e) => {
    setNote(e.target.value);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const [ExpenseTypeOptions, setExpenseTypeOptions] = useState([]);
  const [selectedExpenseType, setSelectedExpenseType] = useState('');

  const fetchExpenseTypes = async () => {
    try {
      const response = await fetchData('OfficeExpenseApi', `/AccountHead/${companyId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(customer => ({
          value: customer.Id,
          label: customer.Description
        }));
        setExpenseTypeOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Expense Types:', error);
    }
  };

  const [showOdometerReading, setShowOdometerReading] = useState(false);
  const handleExpenseTypeChange = (selectedOption) => {
    setSelectedExpenseType(selectedOption);
    setShowOdometerReading(selectedOption && selectedOption.label === 'Fuel');
  };

  useEffect(() => {
    fetchExpenseTypes();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSelectedExpenseType('');
    setNote('');
    setAmount('');
  };

  const AddtoListdata = (e) => {
    e.preventDefault();

    const updatedItem = { ...newItem };

    updatedItem.Note = note;
    updatedItem.Amount = amount;
    updatedItem.selectedExpenseType = selectedExpenseType.label;

    if (selectedExpenseType.label === 'Fuel') {
      updatedItem.OdoMeter = OdoMeter;
    }

    setItemList([...itemList, updatedItem]);

    setNewItem({
      ExpenseType: '',
      Note: '',
      Amount: 0,
      OdoMeter: '',
      ...(selectedOption === 'spare' && { ExpenseType: selectedExpenseType })
    });
    setSelectedExpenseType('');
    setNote('');
    setAmount('');
    setOdometerReading('');
  };

  const handleTripChange = async (selectedOption) => {
    setSelectedTrip(selectedOption);
  };



  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [routeName, setRouteName] = useState('');



  const [selectedTripItemId, setSelectedTripItemId] = useState(null);
  const [TripExpensedata, setTripExpenseData] = useState([]);

  const openModal = async (tripdetails) => {
    // setSelectedTripItemId(tripdetails.id); // Store the selected trip details
    try {
      const response = await fetchData('CustomerReportAPI', `/tmpType/${tripdetails.id}`, token);
      if (response.responseCode === '1111') {
        setTripExpenseData(response.response_data);
        setSelectedTripItemId(response.response_data.Id);
        setRouteName(response.response_data.route);
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching Sale Details:', error);
    }
    setIsModalOpen(true);

  };

  const closeExModal = () => {
    setIsModalOpen(false);
  };

  const submitListData = async () => {
    try {
      if (itemList.length === 0) {
        return;
      }

      const ExpenseItems = itemList.map((item) => ({
        CompanyId: companyId,
        ExpenseType: item.selectedExpenseType,
        Note: item.Note,
        OdoMeter: item.OdoMeter || null,
        Amount: item.Amount,
      }));

      const ExpenseHead = {
        CompanyId: companyId,
        TripID: selectedTripItemId, // Ensure tripId is coming from the selected card
        //TripID: deliverytripid,
        EngineerID: userId,
        ExpenseEntryDate: selectedDate,
        CreatedBy: userId,
        CreatedDate: new Date(),
      };

      const CreatedData = {
        expense: ExpenseHead,
        expenseItem: ExpenseItems,
      };

      postData('ExpenseApi', CreatedData)
        .then((response) => {
          console.log('Data Created success:', response);

          setTimeout(() => { }, 3000);
          window.location.reload();
        })
        .catch((error) => {
          console.error('Data Create error:', error);
        });
    } catch (error) {
      console.error('Data Create error:', error);
    }
  };

  const handleExDelete = (index) => {
    const updatedList = [...itemList];
    updatedList.splice(index, 1);
    setItemList(updatedList);
  };


  return (

    <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto' }}>

      <style>
        {`
        .container::-webkit-scrollbar {
          width: 0.1em;
        }
        .container::-webkit-scrollbar-track {
          background: rgba(255,255,255,0);
        }
        .container::-webkit-scrollbar-thumb {
          background-color: rgba(255,255,255,0);
          border-radius: 4px;
        }
      `}
      </style>
      {/* {roleName === 'Receptionist' && ( */}
      {roleName === 'Receptionist' && (
        <div className="flex flex-wrap justify-between">
          <Card className="w-full sm:w-3/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
            <CardContent>
              <div>
                <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Order</h4>
              </div>
              <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                {Tripdata && Tripdata.map((item) => (
                  <Card key={item.Id} className="customCard" style={{
                    marginBottom: '10px',
                    backgroundColor: '#9B89B3',
                    color: 'white',
                    marginLeft: '30px',
                    height: '120px',
                    boxSizing: 'border-box',
                    '@media (min-width: 600px)': {
                      width: 'calc(20% - 20px)'
                    }
                  }} onClick={() => handleRouteClick(item)}>
                    <CardContent style={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      alignItems: 'left',
                      padding: '10px',
                      boxSizing: 'border-box'
                    }}>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        {item.route}
                      </div>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        Trip Date: {item.TripDate && new Date(item.TripDate).toLocaleDateString('en-GB')}
                      </div>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        Trip No:{item.TripNo}
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ marginLeft: '5px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bolder', color: 'black' }}>Sale Order</div>
                        <Link to={`/TriporderedIndexs/${item.Id}`} style={{ display: 'flex', alignItems: 'center' }}>
                          <IconButton>
                            <ArrowForward />
                          </IconButton>
                        </Link>
                        <Tooltip title="Closing SaleOrder From this Route?">
                          <WrongLocationIcon
                            style={{ color: '#FEFEDF', cursor: 'pointer', marginLeft: '20px' }}
                            onClick={() => openConfirmDialog(item.Id)}
                          />
                        </Tooltip>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>

          {selectedTrip && (
            <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
              <CardContent>
                <div>
                  <h6 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'orangered', fontSize: '15px' }}>Waiting for Order!</h6>
                </div>
                <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {Array.isArray(orderCutsomerdata) && orderCutsomerdata.map(item => (
                    <Card className="customCard" style={{ marginBottom: '10px', backgroundColor: '#CB6D51', color: 'white' }}>
                      <CardContent style={{ height: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', fontWeight: 'bolder' }}>
                        <ShoppingBagIcon />
                        <div style={{ height: '40px', width: '550px', padding: '10px' }}>  {item.Name}{item.AddressLine1}</div>

                        <Link to={`/SaleOrderCreate/${item.ID}/${tripid}`}>
                          <Tooltip title="Create Sale Order">
                            <IconButton style={{ height: '40px' }}>
                              <ArrowForward style={{ color: 'whitesmoke', fontWeight: 'bold' }} />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      )}

      {/* Invoice */}
      {roleName === 'CompanyAdmin' && (

        <div className="flex flex-wrap justify-between">
          <Card className="w-full sm:w-3/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
            <CardContent>
              <div>
                <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Order</h4>
              </div>
              <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                {Tripdata && Tripdata.map((item) => (
                  <Card key={item.Id} className="customCard" style={{
                    marginBottom: '10px',
                    backgroundColor: '#9B89B3',
                    color: 'white',
                    marginLeft: '30px',
                    height: '120px',
                    boxSizing: 'border-box',
                    '@media (min-width: 600px)': {
                      width: 'calc(20% - 20px)'
                    }
                  }} onClick={() => handleRouteClick(item)}>
                    <CardContent style={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      alignItems: 'left',
                      padding: '10px',
                      boxSizing: 'border-box'
                    }}>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        {item.route}
                      </div>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        Trip Date: {item.TripDate && new Date(item.TripDate).toLocaleDateString('en-GB')}
                      </div>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        Trip No:{item.TripNo}
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ marginLeft: '5px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bolder', color: 'black' }}>Sale Order</div>
                        <Link to={`/TriporderedIndexs/${item.Id}`} style={{ display: 'flex', alignItems: 'center' }}>
                          <IconButton>
                            <ArrowForward />
                          </IconButton>
                        </Link>
                        <Tooltip title="Closing SaleOrder From this Route?">
                          <WrongLocationIcon
                            style={{ color: '#FEFEDF', cursor: 'pointer', marginLeft: '20px' }}
                            onClick={() => openConfirmDialog(item.Id)}
                          />
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton aria-label="delete" onClick={(e) => { e.stopPropagation(); handleTripDelete(item.Id); }}>
                            <DeleteIcon style={{ color: 'red' }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>

          {selectedTrip && (
            <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
              <CardContent>
                <div>
                  <h6 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'orangered', fontSize: '15px' }}>Waiting for Order!</h6>
                </div>
                <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {Array.isArray(orderCutsomerdata) && orderCutsomerdata.map(item => (
                    <Card className="customCard" style={{ marginBottom: '10px', backgroundColor: '#CB6D51', color: 'white' }}>
                      <CardContent style={{ height: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px' }}>
                        <ShoppingBagIcon />
                        <div style={{ height: '40px', width: '550px', padding: '10px' }}>  {item.Name}{item.AddressLine1}</div>

                        <Link to={`/SaleOrderCreate/${item.ID}/${tripid}`}>
                          <Tooltip title="Create Sale Order">
                            <IconButton style={{ height: '40px' }}>
                              <ArrowForward style={{ color: 'whitesmoke', fontWeight: 'bold' }} />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      )}

      {roleName === 'CompanyAdmin' && (
        <div className="flex flex-wrap justify-between">
          <Card className="w-full sm:w-3/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
            <CardContent>
              <div>
                <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'darkorange' }}>Invoice</h4>
              </div>
              <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                {TripAllocateData && TripAllocateData.map((item) => (
                  <Card key={item.Id} className="customCard" style={{
                    marginBottom: '10px',
                    backgroundColor: 'yellowgreen',
                    color: 'white',
                    marginLeft: '30px',
                    height: '120px',
                    boxSizing: 'border-box',
                    '@media (min-width: 600px)': {
                      width: 'calc(20% - 20px)'
                    }
                  }} onClick={() => handleRouteClick(item)}>
                    <CardContent style={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      alignItems: 'left',
                      padding: '10px',
                      boxSizing: 'border-box'
                    }}>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        {item.route}
                      </div>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        Trip Date: {item.tripDate && new Date(item.tripDate).toLocaleDateString('en-GB')}
                      </div>
                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        textAlign: 'left'
                      }}>
                        Trip No:{item.tripNo}
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ marginLeft: '5px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bolder', color: 'black' }}>Generate Invoice</div>
                        <Link to={`/DashboardSaleInvoice/${item.id}`} style={{ display: 'flex', alignItems: 'center' }}>
                          <IconButton>
                            <ArrowForward />
                          </IconButton>
                        </Link>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>
          <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
            <CardContent>
              <div>
                <h6 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'blueviolet', fontSize: '15px' }}>Trip Allocate</h6>
              </div>
              <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                {Array.isArray(TripAllocateTostaff) && TripAllocateTostaff.map(item => (
                  <Card className="customCard" style={{ marginBottom: '10px', backgroundColor: '#FBCEB1', color: 'white' }}>
                    <CardContent style={{ height: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      {/* <TripOriginIcon style={{ color: 'darkolivegreen' }} /> */}
                      <div style={{ height: '40px', width: '550px', padding: '10px', color: 'brown', fontSize: '12px', marginLeft: '-20px', fontWeight: 'bolder' }}>  {item.description}</div>

                      {item.isAllocated === false ? (
                        <Tooltip title="Allocate trip to Staff's">
                          <IconButton onClick={() => handleScheduleStaff(item)} style={{ height: '40px' }}>
                            <DepartureBoardIcon style={{ color: 'black', fontWeight: 'bold' }} />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Get Despatch Summary">
                          <IconButton onClick={() => handleDespatched(item)} style={{ height: '40px' }}>
                            <SummarizeSharpIcon style={{ color: 'darkblue', fontWeight: 'bold' }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Delivery */}

      {roleName === 'SalesMan' && (
        <div className="flex flex-wrap justify-between">
          <Card className="w-full sm:w-3/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
            <CardContent>
              <div>
                <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'darkred' }}>Delivery</h4>
              </div>

              <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                {DeliveryData && DeliveryData.map((item) => (
                  <Card key={item.id} className="customCard" style={{
                    marginBottom: '10px',
                    backgroundColor: '#98D2C0',
                    //backgroundColor:'#E7FBE6',
                    color: 'black',
                    marginLeft: '30px',
                    height: '120px',
                    boxSizing: 'border-box',
                    '@media (min-width: 600px)': {
                      width: 'calc(20% - 20px)'
                    }
                  }} onClick={() => handleDeliveryRouteClick(item)}>
                    <CardContent style={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      alignItems: 'left',
                      padding: '10px',
                      boxSizing: 'border-box'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <div>
                          <div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'left'
                          }}>
                            {item.route}
                          </div>
                          <div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'left'
                          }}>
                            {item.description}
                          </div>
                          <div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'left'
                          }}>
                            Trip No: {item.tripNo}
                          </div>
                        </div>

                        <div style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          textAlign: 'right'
                        }}>

                          <Tooltip title="Route Expense">
                            <IconButton aria-label="add" onClick={(e) => { e.stopPropagation(); openModal(item); }}>
                              <AddCardTwoToneIcon style={{ color: 'darkred' }} />
                            </IconButton>
                          </Tooltip>
                        </div>

                      </div>
                      <Tooltip title="Route Closing">
                        <IconButton aria-label="close" onClick={(e) => { e.stopPropagation(); handleDeliveryRouteClose(item); }}>
                          <CloseIcon style={{ color: 'white' }} />
                        </IconButton>
                      </Tooltip>
                    </CardContent>
                  </Card>

                ))}
              </div>
            </CardContent>
          </Card>

          {selectedDeliveryCustomer && (
            <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
              <CardContent>
                <div>
                  <h6 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown', fontSize: '15px' }}>Customer's</h6>
                </div>
                <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {selectedDeliveryCustomer.map((customer) => (
                    <Card key={customer.id} className="customCard" style={{
                      marginBottom: '10px',
                      backgroundColor: customer.balance === customer.billAmount
                        ? '#E69DB8'
                        : customer.balance > 0
                          ? 'red'
                          : 'green',
                      color: 'white',
                      fontSize: '11px',
                      fontWeight: 'bold'
                    }}>
                      <CardContent style={{ height: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ height: '40px', width: '550px', padding: '10px' }}>  {customer.name}</div>

                        <Link to={`/Despatch/${customer.id}`}>
                          <Tooltip title="Create Despatch">
                            <IconButton style={{ height: '40px' }}>
                              <ArrowForward style={{ color: 'whitesmoke', fontWeight: 'bold' }} />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}

        </div>

      )}


      <Modal open={showModal} onClose={closeModal} className={showModal ? 'notification-modal' : ''}>
        <div className="fixed inset-0 flex items-start justify-center z-10" style={{ marginTop: '100px' }}>
          <div className="bg-teal-700 p-6 rounded-lg shadow-lg" style={{ width: '800px', height: '600px', overflowY: 'auto', overflowX: 'auto', marginTop: '-20px' }}>
            <div className="flex justify-end mt-2">
              <Tooltip title="SAVE">

                <Button onClick={submitData} style={{ color: 'whitesmoke', fontWeight: 'bolder', marginLeft: '-2px', backgroundColor: 'darkgreen' }} disabled={isLoading}>
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Allocate"} <CheckCircleIcon />
                </Button>

              </Tooltip>
              <Tooltip title="SAVE">

                <Button onClick={closeModal} style={{ color: 'whitesmoke', fontWeight: 'bolder', marginLeft: '2px', backgroundColor: 'orangered' }} disabled={isLoading}>
                  Close
                </Button>

              </Tooltip>

            </div>

           
            <h4 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'whitesmoke', fontWeight: 'bolder' }}>
              Schedule Trip
            </h4>

            {/* ✅ Show error / success messages */}
            {errorMessage && (
              <div style={{ color: "red", textAlign: "center", marginBottom: "10px", fontWeight: "bold" }}>
                {errorMessage}
              </div>
            )}

            {successMessage && (
              <div style={{ color: "lightgreen", textAlign: "center", marginBottom: "10px", fontWeight: "bold" }}>
                {successMessage}
              </div>
            )}

            {selectedItem && (
              <div className="w-full mb-4" style={{ textAlign: 'center' }}>
                <label className="block tracking-wide text-white text-base font-bold mb-2" htmlFor="description">
                  TripNo : {selectedItem.tripNo} <br></br>  Description : {selectedItem.description}
                </label>

              </div>
            )}
            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-white text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                  SalesMan <span style={{ color: 'red' }}>*</span>
                </label>
                <Select
                  value={selectedSalesMan}
                  onChange={handleSalesManChange}
                  options={salesManOptions}
                  placeholder="SalesMan"
                  isSearchable
                />
              </div>
              {selectedSalesMan && selectedSalesMan.label === 'Other' && (
                <div className="w-1/2 mr-2">
                  <label className="block tracking-wide text-white text-xs font-bold mb-2" htmlFor="otherDriver" style={{ fontSize: '16px' }}>
                    Name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={otherName}
                    onChange={(e) => setOtherName(e.target.value)}
                    type="text"
                    placeholder="Enter Name "
                  />
                </div>
              )}
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-white text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                  Driver <span style={{ color: 'red' }}>*</span>
                </label>
                <Select
                  value={selectedDriver}
                  onChange={handleDriverChange}
                  options={driverOptions}
                  placeholder="Driver"
                  isSearchable
                />
              </div>
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-white text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                  Vehicle Model 
                  
                </label>
                {<Select
                  value={selectedvehicletype}
                  onChange={handleVehicletypeChange}
                  options={vehicletypeOptions}
                  placeholder="Vehicle Model"
                  isSearchable

                />}

              </div>
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-white text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                  Vehicle No. 
                  
                </label>
                {<Select
                  value={selectedVehicle}
                  onChange={handleVehicleChange}
                  options={vehicleOptions}
                  placeholder="Select Vehicle"
                  isSearchable

                />}

              </div>
            </div>
            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-white text-base font-bold mb-2" htmlFor="name">
                  Start Odometer 
                  
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  value={startAutometereReading}
                  onChange={(e) => setStartAutometereReading(e.target.value)}
                  type="text"
                  placeholder="Enter Start Odometer"
                />
              </div>


              <div className='w-full mb-2 flex'>

              </div>
            </div>

          </div>
        </div>
      </Modal>

      <Modal open={showDespatchSUmmaryModal} onClose={closeDespatchModal} className={showDespatchSUmmaryModal ? 'notification-modal' : ''}>
        <div className="fixed inset-0 flex items-start justify-center z-10">
          <div className="bg-teal-900 p-6 rounded-lg shadow-lg" style={{ width: '1500px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
            <div className="flex justify-end mt-2">
              <div className="flex">
                <Tooltip title="Export to EXCEL">
                  <button
                    onClick={handleExportExcel}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: '#CFDAC8',
                      color: 'black',
                      padding: '10px 20px',
                      border: 'none',
                      borderRadius: '5px',
                      fontSize: '14px',
                      marginRight: '10px',
                      fontWeight: 'bolder'
                    }}
                  >
                    Excel
                  </button>
                </Tooltip>

                <Tooltip title="Print Despatch Summary">
                  <button
                    onClick={handlePrint}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: '#E8EAE6',
                      color: 'black',
                      padding: '10px 20px',
                      border: 'none',
                      borderRadius: '5px',
                      fontSize: '14px',
                      marginLeft: '-2px',
                      fontWeight: 'bolder',
                      marginRight: '10px'
                    }}
                  >
                    Print
                  </button>
                </Tooltip>


              </div>

              <Tooltip title="Close despatch Summary">
                <button onClick={closeDespatchModal}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: '#CDD0CB',
                    color: 'black',
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: '5px',
                    fontSize: '14px',
                    marginLeft: '-2px',
                    fontWeight: 'bolder'
                  }}
                  disabled={isLoading}>
                  Close
                </button>
              </Tooltip>
            </div>

            <h5 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'whitesmoke', fontWeight: 'bolder', marginTop: '-50px' }}>Despatch Summary</h5>

            {selecteddespatchItem && (
              <div className="w-full mb-4" style={{ textAlign: 'center' }}>
                <label className="block tracking-wide text-white text-base font-bold mb-2" htmlFor="description">
                  OrderTaken By: {orderTakenby} || Sales Executive: {executive} || TripNo : {selecteddespatchItem.tripNo} || Trip Date & Route : {selecteddespatchItem.description}
                </label>
              </div>
            )}

            <TableContainer component={Paper} style={{ maxHeight: '600px', overflowY: 'auto', scrollbarWidth: 'thin', marginTop: '-10px' }}>
              {/* <TableContainer component={Paper}> */}
              <Table>
                <TableHead sx={{ backgroundColor: '#D3E4CD' }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', width: '10px' }}>Sl.No</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'center', width: '10px' }}> </TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '30px' }}> P.Category</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '30px' }}>Category</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '15px' }}>Item Code</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '30px' }}>Item</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '10px' }}>UOM (Kgs)</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'center', width: '30px' }}>Bundle</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'center', width: '10px' }}>Pieces</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '10px' }}>Quantity
                      (No.Pieces)</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '10px' }}>Total Quantity(kgs)</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '10px' }}>Active Customers</TableCell>
                    <TableCell sx={{ fontWeight: 'bolder', fontSize: '14px', padding: '5px', textAlign: 'left', width: '10px' }}>Remarks</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {Array.isArray(data) && data.length > 0 ? (
                    data.map((rowData, index) => {
                      const showProductCategory = index === 0 || rowData.ProductCategory !== data[index - 1].ProductCategory;
                      const showCategory = index === 0 || rowData.Category !== data[index - 1].Category;
                      const showCustomerId = index === 0 || rowData.CustomerId !== data[index - 1].CustomerId;
                      const showOrderTypeName = index === 0 || rowData.OrderTypeName !== data[index - 1].OrderTypeName;
                      const showsaleremarks = index === 0 || rowData.SaleRemarks !== data[index - 1].SaleRemarks;

                      return (
                        <TableRow
                          key={index}
                          sx={{
                            padding: '3px',
                            height: '32px',
                            backgroundColor: rowData.Total === '' ? 'white' : 'transparent', // Highlight if Total is empty
                          }}
                        >
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'left', width: '10px' }}>
                            {index + 1}
                          </TableCell>

                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'left', width: '20px', fontWeight: 'bolder' }}>
                            {showOrderTypeName ? rowData.OrderTypeName : ''}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'left', width: '20px' }}>
                            {showProductCategory ? rowData.ProductCategory : ''}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'left', width: '20px' }}>
                            {showCategory ? rowData.Category : ''}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'left', width: '20px' }}>
                            {rowData.ItemCode}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'left', width: '20px', color: 'darkblue' }}>
                            {rowData.Item}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'center', width: '20px' }}>
                            {rowData.Kilogram}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'center', width: '20px' }}>
                            {rowData.Bundle}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'center', width: '20px' }}>
                            {rowData.Pieces}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'center', width: '20px' }}>
                            {rowData.Quantity}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'center', width: '20px' }}>
                            {rowData.TotalKilogram}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'center', width: '20px' }}>
                            {showCustomerId ? rowData.CustomerId : ''}
                          </TableCell>
                          <TableCell sx={{ fontSize: '12px', padding: '7px', textAlign: 'center', width: '20px' }}>
                            {showsaleremarks ? rowData.SaleRemarks : ''}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={11} sx={{ textAlign: 'center' }}>No data available.</TableCell>
                    </TableRow>
                  )}
                </TableBody>

              </Table>
            </TableContainer>
          </div>
        </div>
      </Modal >

      <Modal open={showModalDeliveredShopRoute} onClose={closeDeliveredModal} className={showModalDeliveredShopRoute ? 'notification-modal' : ''}>
        <div className="fixed inset-0 flex items-start justify-center z-10" style={{ marginTop: '100px' }}>
          <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '700px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
            <div className="flex justify-end mt-2">
              <Tooltip title="SAVE">
                <Button onClick={RouteclosingsubmitData} style={{ color: 'whitesmoke', fontWeight: 'bolder', marginLeft: '-2px', backgroundColor: 'darkgreen' }} disabled={isLoading}>
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                </Button>
              </Tooltip>
              <Tooltip title="SAVE">
                <Button onClick={closeDeliveredModal} style={{ color: 'whitesmoke', fontWeight: 'bolder', marginLeft: '2px', backgroundColor: 'orangered' }} disabled={isLoading}>
                  Close
                </Button>
              </Tooltip>
              <div>

              </div>

            </div>

            <h4 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'black', fontWeight: 'bolder' }}>Trip Closing</h4>

            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Salesman">
                  Salesman
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="Salesman"
                  value={TripClosingdata.Salesman}
                  type="text"
                  disabled
                />
              </div>

              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Driver">
                  Driver
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="Driver"
                  value={TripClosingdata.Driver}
                  type="text"
                  disabled
                />
              </div>

              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Vehicle">
                  Vehicle
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="Vehicle"
                  value={TripClosingdata.vehicle}
                  type="text"
                  disabled
                />
              </div>
            </div>

            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Vehicle">
                  Route
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:text-black focus:shadow-outline"
                  name="Vehicle"
                  value={TripClosingdata.Description}
                  type="text"
                  disabled
                />
              </div>
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="StartOdometer">
                  End Odometer
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:text-black focus:shadow-outline"
                  name="EndOdometer"
                  value={OdoMeter}
                  onChange={(e) => setOdometerReading(e.target.value)}
                  type="text"
                  placeholder="Enter End Odometer"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal open={isModalOpen} className={isModalOpen ? 'notification-modal' : ''}>

        <div className="fixed inset-0 flex items-start justify-center z-10" style={{ marginTop: '100px' }}>

          <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '700px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
            <div className="button-container-2">

              <Tooltip title="Submit">
                <Button onClick={submitListData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Submit"} <CheckCircleIcon />
                </Button>
              </Tooltip>
            </div>
            <h4 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'darkred' }}>Add Expense</h4>
            <h6 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'darkmagenta' }}>{routeName}</h6>

            <div className="w-full mb-4" style={{ textAlign: 'center' }}>
              <label className="block tracking-wide text-white text-base font-bold mb-2" htmlFor="description">

              </label>
            </div>
            <div className="bg-tabcolor-100 rounded-lg shadow-lg p-6">
              <div className="w-full mb-4 flex">

                <div className="w-1/7 mr-3" style={{ marginTop: '-20px' }}>
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                    Date
                  </label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={date => setSelectedDate(date)}
                    dateFormat="dd/MM/yyyy"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    readOnly
                  />
                </div>

                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                    Expense
                  </label>
                  <Select
                    value={selectedExpenseType}
                    onChange={handleExpenseTypeChange}
                    options={ExpenseTypeOptions}
                    placeholder="--Expense--"
                    isSearchable
                  />
                </div>

              </div>
              <div className="w-full mb-4 flex">
                <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingSlipNumber" style={{ fontSize: '16px' }}>
                    Note
                  </label>
                  <textarea
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Enter Notes"
                    rows={3}
                    maxLength={250}
                  />
                </div>
              </div>
              <div className="w-full mb-4 flex">
                {showOdometerReading && (
                  <div className="w-1/7 mr-3" style={{ marginTop: '-20px', width: '150px' }}>
                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="OdoMeter" style={{ fontSize: '16px' }}>
                      Odometer Reading
                    </label>
                    <input
                      type="text"
                      id="OdoMeter"
                      name="OdoMeter"
                      value={OdoMeter}
                      onChange={(e) => setOdometerReading(e.target.value)}
                      placeholder="Enter Odometer Reading"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                )}
                <div className="w-full md:w-1/2 pr-2" style={{ marginTop: '-20px', width: '150px' }}>
                  <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                    Amount
                  </label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setAmount(value);
                      }
                    }}
                    pattern="^\d*\.?\d*$"
                    maxLength={5}
                  />
                </div>
              </div>
              <br />
              <div className="w-full mb-4 flex">
                <Tooltip title="Add">
                  <Button onClick={AddtoListdata} style={{ marginTop: '-30px', color: 'green', cursor: 'pointer' }}>
                    ADD <CheckCircleIcon />
                  </Button>
                </Tooltip>
                <Tooltip title="Cancel">
                  <Button onClick={closeExModal} style={{ marginTop: '-30px', color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>
                    Cancel<CancelIcon />
                  </Button>
                </Tooltip>
              </div>
              {itemList.length > 0 && (
                <div className="overflow-auto" style={{ overflowY: 'auto' }}>
                  <table className="w-full border-collapse border" style={{ overflowY: 'auto' }}>
                    <thead>
                      <tr className="bg-gray-200 border-b">
                        <th className="px-4 py-2 text-left border-r" style={{ width: '5px' }}>Sl.no</th>
                        <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Expense</th>
                        <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Note</th>
                        <th className="px-4 py-2 text-left border-r" style={{ width: '75px' }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemList.map((item, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}>
                          <td className="px-4 py-2 border-r" style={{ width: '5px' }}>{index + 1}</td>
                          <td className="px-4 py-2 border-r" style={{ width: '500px' }}>{item.selectedExpenseType}</td>
                          <td className="px-4 py-2 border-r" style={{ width: '500px' }}>{item.Note}</td>
                          <td className="px-4 py-2 border-r" style={{ width: '75px', textAlign: 'right', cursor: 'pointer' }}
                            onClick={() => handleExDelete(index)}>{item.Amount}
                            <Tooltip title="Delete"><DeleteIcon style={{ color: 'brown' }} /></Tooltip></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

          </div>
        </div>
      </Modal>

      {/* Conditionally render the table based on the length of itemList */}
      <Dialog
        open={confirmDialogOpen}
        onClose={closeConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Finish Trip?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Delete Trip?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={closeConfirmDialog}
            style={{
              backgroundColor: '#dc3545',
              color: '#ffffff',
              border: '1px solid #dc3545',
              borderRadius: '4px',
              padding: '8px 16px',
              cursor: 'pointer',
              marginRight: '8px',
            }}
          >
            No
          </button>
          <button
            onClick={handleTripDelete}
            style={{
              backgroundColor: '#28a745',
              color: '#ffffff',
              border: '1px solid #28a745',
              borderRadius: '4px',
              padding: '8px 16px',
              cursor: 'pointer',
            }}
          >
            Yes
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmDialogOpen}
        onClose={closeConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Finish Trip?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you Completed taking SaleOrder From This Route?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={closeConfirmDialog}
            style={{
              backgroundColor: '#dc3545',
              color: '#ffffff',
              border: '1px solid #dc3545',
              borderRadius: '4px',
              padding: '8px 16px',
              cursor: 'pointer',
              marginRight: '8px',
            }}
          >
            No
          </button>
          <button
            onClick={handleDelete}
            style={{
              backgroundColor: '#28a745',
              color: '#ffffff',
              border: '1px solid #28a745',
              borderRadius: '4px',
              padding: '8px 16px',
              cursor: 'pointer',
            }}
          >
            Yes
          </button>
        </DialogActions>
      </Dialog>
    </div >
  );
};

export default Home;
